import React, { useEffect, useState } from 'react';
import { Px } from './brand';
import { prefersReducedMotion, useInView } from './useInView';

// Tablet del hero: un loop corto de video (tablet sostenida en el campo,
// estabilizada para que no se mueva) y, encima de la pantalla, capturas reales
// de la app que van cambiando. Las capturas son imágenes y no parte del video
// para que el texto se lea nítido en cualquier pantalla.
// Capturas tomadas de la cuenta de prueba del entorno local (sept 2026).

const VISTAS = [
  { src: '/landing/tablet/satelite.webp', tab: 'Satélite', label: 'Tus cuadros, aguadas y alambrados, sobre la foto satelital.' },
  { src: '/landing/tablet/verde.webp', tab: 'Verde', label: 'El verde de cada cuadro, mes a mes, medido por satélite.' },
  { src: '/landing/tablet/relieve.webp', tab: 'Relieve', label: 'Las curvas de nivel: dónde está el bajo y dónde se junta el agua.' },
  { src: '/landing/tablet/cuadro.webp', tab: 'Cuadro', label: 'Cada cuadro te dice qué parte de su capacidad está usando.' },
  { src: '/landing/tablet/ficha.webp', tab: 'Ficha', label: 'La ficha del cuadro: consumo contra capacidad, año por año.' },
];

const INTERVALO_MS = 3000;

const HeroTablet: React.FC = () => {
  const [reducedMotion] = useState(prefersReducedMotion);
  const [ref, inView] = useInView<HTMLElement>(0.3);
  const [actual, setActual] = useState(0);
  // Cada clic reinicia el intervalo, así la vista elegida se queda los 3 s completos.
  const [vuelta, setVuelta] = useState(0);

  useEffect(() => {
    if (reducedMotion || !inView) return;
    const id = window.setInterval(() => setActual((i) => (i + 1) % VISTAS.length), INTERVALO_MS);
    return () => window.clearInterval(id);
  }, [reducedMotion, inView, vuelta]);

  const elegir = (i: number) => {
    setActual(i);
    setVuelta((v) => v + 1);
  };

  return (
    <figure className="lp-media lp-tablet" ref={ref}>
      <div className="lp-tablet__frame">
        <video
          src="/landing/tablet/hero-tablet.mp4"
          poster="/landing/tablet/hero-tablet.jpg"
          autoPlay={!reducedMotion}
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        />
        <div className="lp-tablet__screen">
          {VISTAS.map((v, i) => (
            <img
              key={v.src}
              src={v.src}
              alt={i === actual ? `Captura de la app: ${v.label}` : ''}
              aria-hidden={i !== actual}
              className={i === actual ? 'on' : undefined}
              width={800}
              height={1175}
              decoding="async"
            />
          ))}
        </div>
      </div>
      <figcaption>
        <p className="lp-tablet__label" aria-live="polite">
          <Px />
          {VISTAS[actual].label}
        </p>
        <div className="lp-tablet__tabs" role="group" aria-label="Vistas del mapa">
          {VISTAS.map((v, i) => (
            <button key={v.tab} type="button" className={i === actual ? 'on' : undefined} aria-pressed={i === actual} onClick={() => elegir(i)}>
              {v.tab}
            </button>
          ))}
        </div>
      </figcaption>
    </figure>
  );
};

export default HeroTablet;
